<!-- =========================================================================================
  File Name: ECommerceItemDetail.vue
  Description: eCommerce Item Detail page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="item-detail-page">
    <!-- <vs-alert color="danger" title="Error Fetching Product Data" :active.sync="error_occured">
      <span>{{ error_msg }}. </span>
      <span>
        <span>Check </span><router-link :to="{name:'ecommerce-shop'}" class="text-inherit underline">All Items</router-link>
      </span>
    </vs-alert> -->

    <vx-card v-if="item_data" :key="item_data._id">
      <template slot="no-body">
        <div class="item-content">
          <!-- Item Main Info -->
          <div class="product-details p-6">
            <div class="vx-row mt-6" v-scrollanimation>
              <div
                class="vx-col md:w-2/5 w-full flex items-center justify-center"
                v-appear:left="{ delay: 100 * 4 }"
              >
                <div class="product-img-container mx-auto  md:mb-0">
                  <b-carousel
                    id="carousel-1"
                    v-model="slide"
                    :interval="4000"
                    controls
                    indicators
                    background="#ababab"
                    img-width="1024"
                    img-height="700"
                    style="text-shadow: 1px 1px 2px #333"
                    @sliding-start="onSlideStart"
                    @sliding-end="onSlideEnd"
                    v-if="checkImages(item_data.home.pic)"
                   
                  >
                    <!-- Slides with image only -->
                    <b-carousel-slide
                      img-src="../../../assets/images/white.jpeg"
                      v-for="image in item_data.home.pic"
                      :key="image.id"
                    >
                     <b-img thumbnail fluid :src="convertImage(image.img.data)" alt="Image 1"></b-img>
                    </b-carousel-slide>
                  </b-carousel>
                 <img src="https://i.pinimg.com/originals/2b/36/2f/2b362f7ea3e8b33f64260f01dd739a48.png" :alt="item_data.name" class="responsive" v-if="!checkImages(item_data.home.pic)"> 
                </div>
              </div>

              <!-- Item Content -->
              <div class="vx-col md:w-3/5 w-full">
                <h2>{{ item_data.home.name }}</h2>

                <p class="my-2">
                  <span
                    >{{ item_data.home.adress }},
                    {{ item_data.home.town }}</span
                  >
                </p>
                <p class="flex items-center flex-wrap">
                  <span
                    class="text-2xl leading-none font-medium text-primary mr-4 mt-2"
                    >XOF {{ item_data.price }}</span
                  >
                  <!-- <span class="pl-4 mr-2 mt-2 border border-solid d-theme-border-grey-light border-t-0 border-b-0 border-r-0"><star-rating :show-rating="false" :rating="item_data.rating" :star-size="20" read-only /></span>
                  <span class="cursor-pointer leading-none mt-2">424 ratings</span> -->
                </p>

                <vs-divider />

                <p>{{ item_data.description }}</p>

                <h3>{{ item_data.bedroom }} Chambres</h3>
                <h3>{{ item_data.bathroom }} Salles de bains</h3>

                <vs-divider />
                <h3>Disponibilite</h3>
                <div class="vx-row">
                  <datepicker
                    :inline="true"
                    v-model="item_data.dateBegin"
                    :disabledDates="disabledDates"
                  ></datepicker>
                  <br />
                  <datepicker
                    :inline="true"
                    v-model="item_data.dateEnd"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </div>
                <vs-divider />
                <!-- Color -->
                <!-- <div class="vx-row">
                  <div class="vx-col w-full">
                    <span class="text-xl font-medium">Color</span>
                    <div class="flex flex-wrap items-center mt-2">
                      <div
                        :class="{'border-transparent': opt_color != color}"
                        class="color-radio rounded-full mx-1 border-2 border-solid cursor-pointer relative"
                        :style="itemColor({color: color, style: ['borderColor']})"
                        v-for="color in available_item_colors"
                        :key="color"
                        @click="opt_color=color">
                          <div class="h-6 w-6 rounded-full absolute" :style="itemColor({color: color, style: ['backgroundColor']})"></div>
                        </div>
                    </div>
                  </div>
                </div>
                /Color -->
                <!-- Quantity -->
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <p class="my-2">
                      <span>Available</span>
                      <span class="mx-2">-</span>
                    </p>
                  </div>

                  <div class="vx-col w-full">
                    <div class="flex flex-wrap items-start mb-4">
                      <!-- Add To Cart Button -->
                      <vs-button
                        class="mr-4 mb-4"
                        icon-pack="feather"
                        icon="icon-shopping-cart"
                        @click="toggleItemInCart(item_data)"
                      >
                        Reserver
                      </vs-button>

  
                      <!-- /Add To Cart Button -->

                      <!-- Wishlist Button -->
                      <vs-button
                        v-if="isInWishList(item_data._id)"
                        key="filled"
                        class="mb-4"
                        icon-pack="feather"
                        icon="icon-heart"
                        color="danger"
                        @click="toggleItemInWishList(item_data)"
                      >
                        Retirer des favoris
                      </vs-button>

                      <vs-button
                        v-else
                        key="border"
                        class="mb-4"
                        type="border"
                        icon-pack="feather"
                        icon="icon-heart"
                        color="danger"
                        @click="toggleItemInWishList(item_data)"
                      >
                        Ajouter aux favoris
                      </vs-button>
                      <!-- /Wishlist Button -->
                    </div>
                  </div>
                </div>
                <!-- /Quantity -->

                <div class="vx-row">
                  <span> Share2Icon </span>
                  <div class="vx-col flex flex-wrap items-center">
                    <vs-button
                      class="mr-4"
                      type="border"
                      icon-pack="feather"
                      color="#1551b1"
                      icon="icon-facebook"
                      radius
                    ></vs-button>
                    <vs-button
                      class="mr-4"
                      type="border"
                      icon-pack="feather"
                      color="#00aaff"
                      icon="icon-twitter"
                      radius
                    ></vs-button>
                    <vs-button
                      class="mr-4"
                      type="border"
                      icon-pack="feather"
                      color="#c4302b"
                      icon="icon-youtube"
                      radius
                    ></vs-button>
                    <vs-button
                      class="mr-4"
                      type="border"
                      icon-pack="feather"
                      color="#405DE6"
                      icon="icon-instagram"
                      radius
                    ></vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Product Feature/Meta Row -->
          <!-- <div class="py-24 mb-16 mt-10 text-center item-features">
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-full">
                <div class="w-64 mx-auto mb-16 md:mb-0">
                  <feather-icon icon="AwardIcon" svgClasses="h-12 w-12 text-primary stroke-current" class="block mb-4" />
                  <span class="font-semibold text-lg">100% Original</span>
                  <p class="mt-2">Chocolate bar candy canes ice cream toffee cookie halvah.</p>
                </div>
              </div>
              <div class="vx-col md:w-1/3 w-full">
                <div class="w-64 mx-auto mb-16 md:mb-0">
                  <feather-icon icon="ClockIcon" svgClasses="h-12 w-12 text-primary stroke-current" class="block mb-4" />
                  <span class="font-semibold text-lg">10 Day Replacement</span>
                  <p class="mt-2">Marshmallow biscuit donut dragée fruitcake wafer.</p>
                </div>
              </div>
              <div class="vx-col md:w-1/3 w-full">
                <div class="w-64 mx-auto">
                  <feather-icon icon="ShieldIcon" svgClasses="h-12 w-12 text-primary stroke-current" class="block mb-4" />
                  <span class="font-semibold text-lg">1 Year Warranty</span>
                  <p class="mt-2">Cotton candy gingerbread cake I love sugar sweet.</p>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <br />
        <br />
        <!-- Related Products -->
        <div class="related-products text-center px-6">
          <div class="related-headings mb-8 text-center">
            <h2 class="uppercase">Les logements de la même catégorie</h2>
            <p></p>
          </div>
          <swiper
            :options="swiperOption"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            :key="$vs.rtl"
            class="related-product-swiper px-12 py-6"
          >
            <swiper-slide
              v-for="item in related_items"
              :key="item._id"
              class="p-6 rounded cursor-pointer"
            >
              <!-- Item Heading -->
              <div class="item-heading mb-4">
                <p class="text-lg font-semibold truncate">{{ item.home.name }}</p>
                <p class="text-sm">
                  
                  <span>{{ item.home.adress }}</span>
                </p>
              </div>

              <!-- Item Image -->
              <div class="img-container w-32 mx-auto my-base">
                <img class="responsive" :src="imageOfHome(item)" :alt="item.name" />
              </div>

              <!-- Item Meta -->
              <div class="item-meta">
                <star-rating
                  :show-rating="false"
                  :rating="item.rating"
                  :star-size="14"
                  class="justify-center"
                  read-only
                />
                <p class="text-lg font-medium text-primary">
                  {{ item.price }} FCFA
                </p>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
          <div v-if="loadingRelated" class="d-flex justify-content-center mb-3">
    <b-spinner label="Loading..."></b-spinner>
  </div>
        </div>
      </template>
    </vx-card>

    
  <div v-if="!item_data" class="d-flex justify-content-center mb-3">
    <b-spinner label="Loading..."></b-spinner>
  </div>
  </div>
  
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import StarRating from 'vue-star-rating'
import Datepicker from 'vuejs-datepicker'
import axios from '@/helpers/axios'

export default {
  components: {
    swiper,
    swiperSlide,
    StarRating,
    Datepicker
  },
  data () {
    return {
      loadingRelated : true,
      slide: 0,
      sliding: null,
      disabledDates: {
        to: null, // Disable all dates up to specific date
        from: null // Disable all dates after specific date
      },
      item_data: null,
      error_occured: false,
      error_msg: '',

      // Related Products Swiper
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 55,
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 55
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 55
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 55
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 55
          }
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      // Below is data which is common in any item
      // Algolia's dataSet don't provide this kind of data. So, here's dummy data for demo
      available_item_colors: [
        '#7367F0',
        '#28C76F',
        '#EA5455',
        '#FF9F43',
        '#1E1E1E'
      ],
      opt_color: '#7367F0',
      is_hearted: false,

      related_items: []
    }
  },
  computed: {
    item_qty () {
      const item = this.$store.getters['eCommerce/getCartItem'](
        this.item_data._id
      )
      return Object.keys(item).length ? item.quantity : 1
    },
    itemColor () {
      return (obj) => {
        const style_obj = {}

        obj.style.forEach((p) => {
          style_obj[p] = obj.color
        })

        return style_obj
      }
    },
    isInWishList () {
      return (itemId) => this.$store.getters['eCommerce/isInRentalHouseWishList'](itemId)
    },
    isInCart () {
      return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
    }
  },
  methods: {
    imageOfHome (item) {
      if (item.home.pic.length > 0) {
        return `data:image/jpg;base64,${ item.home.pic[0].img.data}`
      }
      return 'https://i.pinimg.com/originals/2b/36/2f/2b362f7ea3e8b33f64260f01dd739a48.png'
    },
    checkImages (item) {
      if (item.length > 0) {
        return true
      }
      return false
    },
    onSlideStart () {
      this.sliding = true
    },
    onSlideEnd () {
      this.sliding = false
    },
    convertImage (data) {
      return `data:image/jpg;base64,${data}`
    },
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleRentalHouseInWishList', item)
    },
    toggleItemInCart (item) {
      this.$store.dispatch('eCommerce/addItemInCart', item)
      this.$router.push('/checkout').catch(() => {})

    },
    async fetch_item_details (itemId) {
      // axios.get('sale').

      this.disabledDates = await axios.get(`/home/rental/${itemId}`
      ).then((response) => {
        return {
          to: new Date(response.data.dateBegin),
          from: new Date(response.data.dateEnd)
        }

        // console.log(this.item_data)
      })
      this.item_data = await axios.get(`/home/rental/${itemId}`
      ).then((response) => {
        return response.data
        // console.log(this.item_data)
      })
      this.related_items = await axios.get(`/home/rental/find/withMultipleQuery/?place=${this.item_data.home.adress}&categoryLocation=${this.item_data.categoryLocation}`
      ).then((response) => {
        this.loadingRelated = false
        return response.data
        // console.log(this.item_data)
      })
    }
  },
  created () {
    this.fetch_item_details(this.$route.params.item_id)
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";

#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .item-features {
    background-color: #f7f7f7;

    .theme-dark & {
      background-color: $theme-dark-secondary-bg;
    }
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
    // padding-right: 2rem;
    // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1),
          0 5px 12px 0 rgba(0, 0, 0, 0.08) !important;

        .theme-dark & {
          background-color: $theme-light-dark-bg;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(0.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0;
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
</style>
